import { TextField } from '@mui/material';
import { Control, Controller, FieldValues } from 'react-hook-form';

interface IProps {
  control: Control<FieldValues, any>; // eslint-disable-line
  name: string;
  onBlur?: () => void;
  onChange?: () => void;
  children: React.ReactNode;
}

export function FSSelect({
  control,
  name,
  onBlur,
  onChange,
  children,
}: IProps) {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={''}
      render={({ field }) => (
        <TextField
          select
          {...field}
          type=""
          onBlur={() => {
            field.onBlur();
            onBlur?.();
          }}
          onChange={(event) => {
            field.onChange(event);
            onChange?.();
          }}
          sx={{
            my: 1,
            width: '100%',
          }}
        >
          {children}
        </TextField>
      )}
    />
  );
}
